import { Errors } from './errors';
import { Component, Input, OnInit, ElementRef, Injector, OnDestroy } from '@angular/core';
import { ErrorList } from './error-list.model';
import { Overlay, OverlayRef, } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ErrorPromptMessagesComponent } from './error-prompt-messages.component';
import { Dimensions } from './dimensions';


@Component({
  selector: 'error-prompt',
  templateUrl: './error-prompt.component.html',
  styleUrls: ['./error-prompt.component.css'],
})
export class ErrorPromptComponent implements OnInit, OnDestroy {

    // Properties
    @Input() insideFlex: boolean; // deprecated - do not use
    @Input() minWidth: number;
    @Input() maxWidth: number;
    public overlayRef: OverlayRef;

    private _errorList: ErrorList[];
    public get errorList(): ErrorList[] {
    return this._errorList;
    }
    @Input() public set errorList(value: ErrorList[]) {
        this._errorList = value;
        if (this._errorList && this._errorList.length > 0) {
            setTimeout(() => {
                this.showErrors();
            }, 0);
        }
        else {
            this.hideErrors();
        }
    }

    // Class Functions
    constructor(
        private _eref: ElementRef,
        private overlay: Overlay,
        private injector: Injector
    ) {}

    // Event Functions
    errorCircleClick() {
        // PRE: the error circle is clicked
        // POST: shows the error messages overlay
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.hideErrors();
        } else {
            this.showErrors();
        }
    }

    showErrors() {
        if (!this.overlayRef || !this.overlayRef.hasAttached()) {
            const position = this.overlay
                .position()
                .flexibleConnectedTo(this._eref.nativeElement.parentElement)
                .withPositions([
                    {
                        offsetY: -5,
                        offsetX: -10,
                        originX: 'end',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'top',
                        weight: 1
                    }
                ]);
            this.overlayRef = this.overlay.create({
                positionStrategy: position
            });
            const injector = Injector.create(
                [
                    {
                        provide: Errors,
                        useValue: new Errors(this.errorList),
                    },
                    {
                        provide: OverlayRef,
                        useValue: this.overlayRef
                    },
                    {
                        provide: Dimensions,
                        useValue: {
                            minWidth: this.minWidth,
                            maxWidth: this.maxWidth
                        }
                    }
                ],
                this.injector
                );
            const messagePortal = new ComponentPortal(ErrorPromptMessagesComponent, null, injector);
            this.overlayRef.attach(messagePortal);
        }
    }

    hideErrors() {
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.dispose();
        }
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        // POST: removes the error message overlay
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }
}

